import React, { useRef } from 'react';
import { I2cDataTable } from '@webcomponents/i2cwebcomponents/dist/react';
import "./basicdatatable.css";
import EnableCheckboxRenderer from './EnableCheckboxRenderer';
import MandatoryCheckboxRenderer from './MandatoryCheckboxRenderer';
const BasicDataTable = ({ columnDefs, data, updateData, class: isDefaultHeight }) => {
    // const [gridOptions, setGridOptions] = useState({});
    const dataTable = useRef();

    const noData = [
        {
            description:
                'We had some trouble loading this page. Please refresh the page to try again or get in touch if the problem sticks around!',
            type: 'noData',
            icon: 'outline-info-circle',
        }
    ];
    // useEffect(() => {
    //     const loadDataFromLocalStorage = () => {
    //         const storedData = localStorage.getItem(localStorageKey);
    //         if (storedData) {
    //             return JSON.parse(storedData);
    //         }
    //         return data;
    //     };

    //     const options = {
    //         columnDefs: columnDefs,
    //         rowSelection: 'multiple',
    //         rowData: loadDataFromLocalStorage(),
    //         defaultColDef: {
    //             resizable: false,
    //             flex: 1,
    //         },
    //         onCellClicked: (params) => {
    //             // Pass localStorageKey to each cell renderer
    //             params.localStorageKey = localStorageKey;
    //         },
    //         onFirstDataRendered: (params) => {
    //             // Optionally store API in a ref or use grid options
    //         },
    //     };

    //     setGridOptions(options);
    // }, [columnDefs, data, localStorageKey]);

    const gridOptions = {
        columnDefs: columnDefs,
        rowSelection: 'multiple',
        rowData: data,
        defaultColDef: {
            resizable: false,
            flex: 1,
        },
        components: {
            enableCheckboxRenderer: EnableCheckboxRenderer,
            mandatoryCheckboxRenderer: MandatoryCheckboxRenderer,
        },
        frameworkComponents: {
            enableCheckboxRenderer: EnableCheckboxRenderer,
            mandatoryCheckboxRenderer: MandatoryCheckboxRenderer,
        },
        onCellClicked: (params) => {
            params.updateData = updateData; // Pass the callback to each cell renderer
        },
    };


    return (
        <div>
            <I2cDataTable id="dataTable1" gridOptionInput={gridOptions} notFound={noData} headerBlock className={`basicDataTable ${isDefaultHeight ? 'defaultHeight' : ''}`}
                ref={dataTable}>
            </I2cDataTable>
        </div>
    )
}

export default BasicDataTable